import { format, addDays } from "date-fns";
import { useSignal } from "@preact/signals-react";

import ModalForm from "componentsv2/modal/ModalForm";
import Loading from "componentsv2/widgets/Loading";
import CalendarHeader from "./CalendarHeader";
import CalendarHeaderRow from "./CalendarHeaderRow";
import CalendarBody from "./CalendarBody";
import { useMethod } from "hooks/records";
import { getStorage } from "store/local";
import helper from "./helper";
import { insertRecord } from "storev2/formStore";

const fmtDate = "yyyy-MM-dd";

function CalendarTable(props) {
  const { rooms, selectedDate, reload } = props;
  const openFolio = useSignal(false);
  const recSstoreId = useSignal(null);
  const session = getStorage("ctxSession");
  const view = useSignal(null);

  const dates = fillUpDates();

  const selectedDateFmt = format(selectedDate.value, fmtDate);
  const ctxArgs = {
    model: "hotel.folio",
    method: "get_rack",
    args: [{ start_date: selectedDateFmt, shop: session.shop }],
  };

  const { data, refetch } = useMethod(ctxArgs);
  // const { setTrigger } = useWizardStore.getState();
  // setTrigger(refetch);

  const rack = new Map();
  if (data) {
    data.rooms.forEach((room) => {
      rack.set(room["id"], []);
    });

    data.folios.forEach((folio) => {
      if (!folio["room."]) {
        return;
      }
      const room_id = folio["room."].id;
      const roomFo = rack.get(room_id);
      roomFo.push(helper.convertFolio(folio));
    });
    data.mnts.forEach((mnt) => {
      const room_id = mnt["room."].id;
      const roomMnt = rack.get(room_id);
      roomMnt.push(helper.convertOpMant(mnt));
    });
    data.folios;
  }

  const ctxPrices = {
    model: "hotel.rate_plan",
    method: "get_prices_by_accommodation",
    args: [{ start_date: selectedDateFmt }],
  };
  const { data: prices, isLoading } = useMethod(ctxPrices);

  function fillUpDates() {
    // Fill up dates in component state
    const dates = [];
    const day = addDays(selectedDate.value, -4);
    for (let x = 0; x < 34; x++) {
      dates.push(addDays(day, x));
    }
    return dates;
  }

  function actionMoveBooking(singleBooking, room, newStartDate, newEndDate) {
    const allBookings = helper.moveBooking(
      singleBooking,
      room,
      newStartDate,
      newEndDate,
    );
    if (allBookings === false) {
      console.log("Unable to move to target date");
    }
  }

  function actionCreateBooking(singleBooking) {
    console.log("actionCreateBooking...");
  }

  function actionCanExistBooking(
    singleBooking,
    room,
    newStartDate,
    newEndDate,
  ) {
    return helper.canExistBooking(
      singleBooking,
      room,
      newStartDate,
      newEndDate,
    );
  }

  async function handleOpenFolio(recId, layout) {
    if (!layout) return;
    recSstoreId.value = await insertRecord(recId, layout.model, layout);
    view.value = layout;
    openFolio.value = true;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="r-calendar mx-6 relative isolate overflow-auto max-h-[calc(100vh-10rem)]">
      <table
        id="hotel-rack-calendar"
        className="mb-12 border-solid border border-gray-400 r-calendar-main-table"
      >
        <thead className="sticky top-0 z-50">
          <CalendarHeader dates={dates} />
          {data && (
            <CalendarHeaderRow
              title={"OCC. RATE"}
              attr={"occ_rate"}
              data={Object.values(data.occ_rate)}
            />
          )}
        </thead>
        <CalendarBody
          rack={rack}
          dates={dates}
          rooms={rooms}
          prices={prices}
          handleOpenFolio={handleOpenFolio}
        />
      </table>
      {openFolio && (
        <ModalForm
          storeId={recSstoreId}
          openModal={openFolio}
          layout={view.value}
          onClose={() => (openFolio.value = false)}
        />
      )}
    </div>
  );
}

export default CalendarTable;
